import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Atendimento } from 'src/app/core/atendimento';
import { Rotas } from 'src/app/core/rotas';
import { BaseService } from '../base/base.service';


@Injectable({
  providedIn: 'root'
})
export class AtendimentosService extends BaseService<Atendimento> {
  
  constructor(http: HttpClient) {
    super(http, Rotas.ATENDIMENTO);
  }

  getAllContratosProjetosProgramasByCombo() {
    return this.http.get(`${Rotas.ATENDIMENTO}combo/`);
  }
}
